import { render, staticRenderFns } from "./OptionsList.vue?vue&type=template&id=477be3c4&"
import script from "./OptionsList.vue?vue&type=script&lang=js&"
export * from "./OptionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports